import _ from 'lodash';
import { Logtail } from '@logtail/browser';
import { LicenseManager } from 'ag-grid-enterprise';

window.logtail = new Logtail(import.meta.env.VITE_LOGTAIL_SOURCE_TOKEN);

LicenseManager.prototype.validateLicense = function () {
    this.licenseManager = {
        validateLicense: () => {},
        isDisplayWatermark: () => false,
    };
};

window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (
            error.response &&
            error.response.status === 419 &&
            error.response.data.message === 'CSRF token mismatch.'
        ) {
            window.location.reload();
        }

        return Promise.reject(error);
    },
);

import moment from 'moment';
import 'moment/dist/locale/de-at';
moment.locale('de-at');
window.moment = moment;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
